import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import LayoutGap from "%/dynamic-component-editor/options/layout-gap";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";

export default class FeedLayoutOptions extends BaseOptionsBundle {

  optionTitle = "Layout";
  static optionClassName = "i-feed-layout";
  inspectorToolGroup = "feedLayout";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.GROUPED_OPTIONS_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      new LayoutGap(),
      new MaxWidth(),
      new MinWidth(),
      new LayoutWidth({ "default": "fill" }),
    ]);
  }
}
